
import React from "react";

interface IReleaseNotes {
}

const release_notes = [
	{
		date: '2025-05-15',
		version: '1.0.46',
		environment: 'production',
		notes: [
			{
				area: 'Shift the About page ',
				note: 'Shifted the About page to appear under the Administration tab and updated release notes.'
			},
			{
				area: 'Update Citaiton Details with citation number',
				note: 'Changing the citation number to a duplicate value is now prevented.'
			},
			{
				area: 'Mine Configuration Text',
				note: 'Mines that are not configured in the Predictive Compliance application, the text "(not configured)" is now displayed.'
			}
		]
	},
	{
		date: '2025-05-05',
		version: '1.0.45',
		environment: 'production',
		notes: [
			{
				area: 'Regions and Company Email Notification Groups',
				note: 'Overwrite old data in state when we change customer.'
			},
			{
				area: 'Password Auto-Fill',
				note: 'Disabled auto-fill password.'
			}
		]
	},
	{
		date: '2025-04-18',
		version: '1.0.44',
		environment: 'production',
		notes: [
			{
				area: 'The yellow line was missing on the % S&S Citations graph',
				note: 'Updated the stored procedure to fetch data only for the selected mine.'
			},
			{
				area: '133 S&S violations per 100 inspection hours',
				note: 'Updated the stored procedure to fetch data only for the selected mine.'
			}
		]
	},
	{
		date: '2025-04-16',
		version: '1.0.43',
		environment: 'production',
		notes: [
			{
				area: 'Inspector days seem Incorrect',
				note: 'Controller name filter applied on inspection data.'
			}
		]
	},
	{
		date: '2025-04-15',
		version: '1.0.42',
		environment: 'production',
		notes: [
			{
				area: 'There is a citation listed as S&S, however on the “notes” page, it is listed as No',
				note: 'Used correct database field on notes UI.'
			}
		]
	},
	{
		date: '2025-04-11',
		version: '1.0.41',
		environment: 'production',
		notes: [
			{
				area: 'Tableau Sign in issue',
				note: 'Re-publish woorkbooks and datasource.'
			}
		]
	},
	{
		date: '2025-04-04',
		version: '1.0.40',
		environment: 'production',
		notes: [
			{
				area: 'Accidents count is not accurate',
				note: 'Added Controller Name filter on accidents data in tableau.'
			},
			{
				area: 'Peabody SFTP hostkey updation',
				note: 'Updated SFTP hostkey.'
			}
		]
	},
	{
		date: '2025-03-26',
		version: '1.0.39',
		environment: 'production',
		notes: [
			{
				area: 'Showing a high risk on both Criteria 3 and 6 ',
				note: 'Added MineId Filter.'
			}
		]
	},
	{
		date: '2025-03-21',
		version: '1.0.38',
		environment: 'production',
		notes: [
			{
				area: 'Penalty Calculation 2025',
				note: 'Add new peanlty calculation for 2025.'
			}
		]
	},
	{
		date: '2025-01-27',
		version: '1.0.37',
		environment: 'production',
		notes: [
			{
				area: 'Email change and removed text ',
				note: 'Changed email from zsavit to fieldsupport@iwtwireless.com and removed email related text from privacy policy page and press release page.'
			}
		]
	},
	{
		date: '2024-12-04',
		version: '1.0.36',
		environment: 'production',
		notes: [
			{
				area: 'Mine deletion doesn\'t work ',
				note: 'Corrected route to fix this mine deletion.'
			}
		]
	},
	{
		date: '2024-10-30',
		version: '1.0.35',
		environment: 'production',
		notes: [
			{
				area: 'Event number in inspection should accept alphanumeric ',
				note: 'Changed alphanumeric regex for event number.'
			}
		]
	},
	{
		date: '2024-10-25',
		version: '1.0.34',
		environment: 'production',
		notes: [
			{
				area: 'Mine and Controller fields on the Analytics page are not being populated',
				note: 'Operator Begin Date was null for some of the mines, which caused exceptions to be thrown and prevented the flat file data from being imported into the database correctly.'
			}
		]
	},

	{
		date: '2024-10-16',
		version: '1.0.33',
		environment: 'production',
		notes: [
			{
				area: 'Administrators and Company Users can Login when not Enabled',
				note: 'Fixed issue so no user should be able to login if their account is not Enabled.'
			},
			{
				area: 'Display account enabled info about users',
				note: 'Displayed enabled user account in the Administrator Users list, Company Users list, and Usage Metrics list.'
			},
			{
				area: 'Company Subscription End Date',
				note: 'Added a "Subscription End Date" to Companies. It is displayed in the Company list in Administration.'
			},
			{
				area: 'Require Company Name on Create',
				note: 'Company Name is required, not blank or spaces, and it should be unique.'
			},
			{
				area: 'Deleting a Company is not functioning properly',
				note: 'Added cascading deletions on company deletions.'
			}
		]
	},
	{
		date: '2024-06-19',
		version: '1.0.32',
		environment: 'production',
		notes: [
			{
				area: 'Export Citations to CSV',
				note: 'The issue with improperly labeled and unnecessary columns in the Q3 Carlsbad MSHA Inspection CSV download has been fixed, with correct columns (green) retained and incorrect ones (red) addressed, along with the removal of columns Y–BV (yellow).'
			}
		]
	},
	{
		date: '2024-06-19',
		version: '1.0.31',
		environment: 'production',
		notes: [
			{
				area: 'New Feature for the Column filters and design bug fix',
				note: 'Added Citation table more columns filter options and fixed the sub menu yellow highlight issue'
			}
		]
	},
	{
		date: '2024-04-20',
		version: '1.0.30',
		environment: 'production',
		notes: [
			{
				area: 'User Activity Tracking',
				note: 'Table listing each user’s company name, first activity date, last activity date, and total days visited.'
			}
		]
	},
	{
		date: '2024-04-18',
		version: '1.0.29',
		environment: 'production',
		notes: [
			{
				area: 'Penalty Calculation 2024',
				note: 'Add new peanlty calculation for 2024.'
			}
		]
	},
	{
		date: '2024-01-24',
		version: '1.0.28',
		environment: 'production',
		notes: [
			{
				area: 'Some charts only display data for the selected mine (',
				note: 'Charts are correctly displaying values for "All States," "Company Mines," and "State" along with the selected mine.'
			}
		]
	},
	{
		date: '2023-12-04',
		version: '1.0.27',
		environment: 'production',
		notes: [
			{
				area: 'Respect user designated column order for Citation Export',
				note: 'Taking the column numbers from UI in the consideration while exporting the data.'
			}
		]
	},
	{
		date: '2023-11-17',
		version: '1.0.26',
		environment: 'production',
		notes: [
			{
				area: 'Vacate Citation Functionality.',
				note: 'Add checkbox for Vacated citations.'
			}
		]
	},
	{
		date: '2023-11-16',
		version: '1.0.25',
		environment: 'production',
		notes: [
			{
				area: 'Mine State Chart',
				note: 'Two charts are identical.'
			}
		]
	},
	{
		date: '2023-11-12',
		version: '1.0.24',
		environment: 'production',
		notes: [
			{
				area: 'Peabody Export issue with vacated Citation',
				note: 'Stop the citation flow in the Export.'
			}
		]
	},
	{
		date: '2023-10-25',
		version: '1.0.23',
		environment: 'production',
		notes: [
			{
				area: 'Prairie State Penalty and Penalty GFE calculations stopped 8/10/2023',
				note: 'MSHA data is null for the mine.'
			}
		]
	},
	{
		date: '2023-03-20',
		version: '1.0.22',
		environment: 'production',
		notes: [
			{
				area: 'Form errors 14, 17, and 18',
				note: 'Null condition issue.'
			}
		]
	},
	{
		date: '2023-06-09',
		version: '1.0.21',
		environment: 'production',
		notes: [
			{
				area: 'User not able to login',
				note: 'User is not able to reset password & login.'
			}
		]
	},
	{
		date: '2023-10-22',
		version: '1.0.20',
		environment: 'production',
		notes: [
			{
				area: 'Mine state failing',
				note: 'Database changes to resolve it.'
			}
		]
	},
	{
		date: '2023-08-08',
		version: '1.0.19',
		environment: 'production',
		notes: [
			{
				area: 'UI Rebranding',
				note: 'New icon added & theme changed.'
			}
		]
	}, {
		date: '2023-08-03',
		version: '1.0.18',
		environment: 'production',
		notes: [
			{
				area: 'Fix Citation Download Inspection Type Issue',
				note: 'Downloading the citation will now show the inspection type in their original format.'
			}
		]
	}, {
		date: '2023-04-20',
		version: '1.0.17',
		environment: 'production',
		notes: [
			{
				area: 'Add Weekly, Monthly, Quarterly, Yearly Buttons Filter',
				note: 'User can now select range by clicking on the buttons.'
			}
		]
	}, {
		date: '2023-04-13',
		version: '1.0.16',
		environment: 'production',
		notes: [
			{
				area: 'Citation Date Range Reset Fix',
				note: 'Date range preference is stored, Henceforth user selected date range will automatically popup till the next login.'
			}
		]
	}, {
		date: '2023-03-31',
		version: '1.0.15',
		environment: 'production',
		notes: [
			{
				area: 'Session Expiration Issue Fix',
				note: 'If JWT gets expired, the screen will automatically redirect to Login Page.'
			}
		]
	}, {
		date: '2023-03-14',
		version: '1.0.14',
		environment: 'production',
		notes: [
			{
				area: '2023 Penalty Update',
				note: 'Citations will now be calculated on the basis of new 2023 updates.'
			},
			{
				area: 'Update v1 email details',
				note: 'Removed earlier references of from, to & SendGrid details.'
			}
		]
	},
	{
		date: '2023-02-27',
		version: '1.0.13',
		environment: 'production',
		notes: [
			{
				area: 'Recaptcha Issue Fixed',
				note: 'Forgot password recaptcha issue fixed.'
			},
			{
				area: 'Email Issue Fixed',
				note: 'Notifications emails will now be sent that earlier were not being sent.'
			},
			{
				area: 'Started Versioning V2',
				note: 'Each deployed versions can now be seen.'
			}
		]
	}, {
		date: '2023-02-20',
		version: '1.0.12',
		environment: 'production',
		notes: [
			{
				area: 'Sendgrid changes',
				note: 'Update Email templates & API key.',
			}
		]
	},
	{
		date: '2023-02-12',
		version: '1.0.11',
		environment: 'production',
		notes: [
			{
				area: 'Make 18A & 18B field optional',
				note: ' Citation can be uploaded when 18A & 18B are empty.',
			}
		]
	}, {
		date: '2023-02-09',
		version: '1.0.10',
		environment: 'production',
		notes: [
			{
				area: 'Make 14E & 14F field optional',
				note: ' Citation can be uploaded when 14E & 14F are empty.',
			}
		]
	}, {
		date: '2023-01-30',
		version: '1.0.9',
		environment: 'production',
		notes: [
			{
				area: 'Citation Delete',
				note: ' Ability to delete citations.',
			}
		]
	},
	{
		date: '2022-11-10',
		version: '1.0.8',
		environment: 'production',
		notes: [
			{
				area: 'Citation Scan',
				note: 'Fixed date validation issues preventing saving scan results.',
			}
		]
	},
	{
		date: '2022-11-03',
		version: '1.0.7',
		environment: 'production',
		notes: [
			{
				area: '10k/10q',
				note: 'Fixed calculation totals in 10k and 10q.',
			},
			{
				area: 'Citation Edit',
				note: 'Fixed issues with date inputs, where the time chanages would effect the date, and visa versa.',
			},
			{
				area: 'Citation View',
				note: 'Fixed an issue where Mine name and mine id were not being displayed.',
			},
			{
				area: 'Citation Edit',
				note: 'Fixed an issue where time zones would change times after saving.',
			}
		]
	},
	{
		date: '2022-08-24',
		version: '1.0.6',
		environment: 'production',
		notes: [
			{
				area: 'OCR',
				note: 'Improved OCR model by adding training documents, including significant improvements to served to, initial action and written notice.',
			}
		]
	},
	{
		date: '2022-07-08',
		version: '1.0.5',
		environment: 'production',
		notes: [
			{
				area: 'Logging',
				note: 'Added authentication logs.',
			}
		]
	},
	{
		date: '2022-07-07',
		version: '1.0.4',
		environment: 'production',
		notes: [
			{
				area: 'Citation Scan',
				note: 'Improved logic for matching citation uploads to mines.',
			},
			{
				area: 'Citation Scan',
				note: 'Ability to identify unique citations with existing citation numbers.',
			}
		]
	},
	{
		date: '2022-05-25',
		version: '1.0.3',
		environment: 'production',
		notes: [
			{
				area: 'Citation Scan',
				note: 'Upgraded to latest Azure Forms library.',
			},
			{
				area: 'Citation Scan',
				note: 'Fixed issue where empty date fields would show up as invalid.',
			}
		]
	},
	{
		date: '2022-04-22',
		version: '1.0.2',
		environment: 'production',
		notes: [
			{
				area: 'Citation Table',
				note: 'Column selections are persistent across sessions.',
			},
			{
				area: 'Citation Export',
				note: 'Added date issued, terminated, and termination times.',
			},
			{
				area: 'Citation Table',
				note: 'Penalty calc GFE has been promoted to a selectable column and will show up in the report if selected.',
			},
			{
				area: 'Citation Export',
				note: 'Fixed Injury or Illness values exporting with the Likelihood values.',
			},
			{
				area: 'Citation Export',
				note: 'Condition or practice column new lines are converted to spaces for the export process.',
			},
			{
				area: 'Citation Export',
				note: 'Trailing zeroes in section of act are preserved.',
			}
		]
	},
	{
		date: '2022-03-25',
		version: '1.0.1',
		environment: 'production',
		notes: [
			{
				area: 'Citations: ',
				note: 'Export citation, with all columns selected will now export custom company fields.',
			},
			{
				area: 'Citation Notes',
				note: 'Custom note fields now display a generic name if no display name is provided.',
			},
			{
				area: 'Citation Notes',
				note: 'Fixed an issue where custom long text fields would not appear in the citation notes modal.',
			}
		]
	},
	{
		date: '2022-02-05',
		version: '1.0.0',
		environment: 'production',
		notes: [
			{
				area: 'General: ',
				note: 'Added about section added with release notes.',
			},
			{
				area: 'Admin',
				note: 'Delete company now deletes all associated data.',
			},
			{
				area: 'Landing',
				note: 'Removed featured company section from site landing.',
			}
		]
	}
]

const getEnvironmentDiv = (env: string) => {
	if (env === 'beta' || env === 'development' || env === 'staging') {
		return <span>{env}</span>
	}
	return null;
}

const ReleaseNotes: React.FC<IReleaseNotes> = (props) => {

	return (
		<div>
			<h1>Version: {release_notes[0].version}</h1>

			<h2>History</h2>

			{release_notes.map((rn, rnIndex) => {
				return (
					<div key={rnIndex}>
						<section>
							<article>
								Version {rn.version} {getEnvironmentDiv(rn.environment)}
								<br />
								Release Date: {rn.date}
								<ul>
									{rn.notes.map((note, noteIndex) => {
										return (
											<li key={noteIndex}>{note.area}: {note.note}</li>
										)
									})}
								</ul>
							</article>
						</section>
						<hr></hr>
					</div>
				)
			})}
		</div>

	)

}
export default ReleaseNotes